import { useState } from 'react';
import { BadgeCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PcmpConfirmDisbursementDialog } from './PcmpConfirmDisbursementDialog';

interface PcmpConfirmDisbursementButtonProps {
  proposalId: number;
  refNo: string;
  /** The API's canConfirmDisbursement; false hides the button. */
  canConfirm: boolean;
}

/** The submitting MO's Confirm of an Accounts payout, opening its dialog. */
export function PcmpConfirmDisbursementButton({
  proposalId,
  refNo,
  canConfirm,
}: PcmpConfirmDisbursementButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!canConfirm) return null;

  return (
    <>
      <Button type="button" size="sm" onClick={() => setIsOpen(true)} className="gap-1.5">
        <BadgeCheck className="size-3.5" />
        Confirm Disbursement
      </Button>
      {/* Mounted only while open, so it starts empty. */}
      {isOpen ? (
        <PcmpConfirmDisbursementDialog
          proposalId={proposalId}
          refNo={refNo}
          onClose={() => setIsOpen(false)}
        />
      ) : null}
    </>
  );
}
